// extracted by mini-css-extract-plugin
module.exports = {"assignmentHeader":"style__assignmentHeader__Ddn5p"};